import React, { FC } from 'react';

import { IIconType } from './types';

export const IconAddPlus: FC<IIconType> = ({ color = 'black', size = 16 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.25 7.5H11.75"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 11.25L8 3.75"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
